import React from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { MobileMenuHeader } from './header';
import { MobileMenuNavItem } from './navItem';
import { MobileMenuFooter } from './footer';
import { QuickLinks } from '../DesktopSidebar/quickLinks';

export const MobileMenu = ({ isOpen, setIsOpen, sidebarNavigation }) => {
  return (
    <Dialog open={isOpen} onClose={setIsOpen} className="relative z-50 lg:hidden">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-closed:opacity-0"
      />

      <div className="fixed inset-0">
        <DialogPanel
          transition
          className="fixed inset-0 flex transform flex-col transition duration-300 ease-in-out data-closed:-translate-y-full data-closed:opacity-0"
        >
          <MobileMenuHeader setIsOpen={setIsOpen} />

          {/* Body */}
          <div className="bg-pdwhite flex grow flex-col gap-y-5 overflow-y-auto px-4 pb-4">
            <nav className="flex flex-1 flex-col">
              <div className="-mx-2 block h-full space-y-1 divide-y divide-gray-100">
                {sidebarNavigation.map((item) => (
                  <MobileMenuNavItem key={item} item={item} setIsOpen={setIsOpen} />
                ))}
                <div className='p-5'>
                  <QuickLinks view='mobile' />
                </div>
              </div>
              <MobileMenuFooter setIsOpen={setIsOpen} />
            </nav>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
